import { withPazePaymentMethodProps } from 'viewModel/paze/pazePaymentMethod/withPazePaymentMethodProps';

import PazePaymentMethod from 'components/Paze/PazePaymentMethod/PazePaymentMethod';

export default withPazePaymentMethodProps(PazePaymentMethod);
